// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/job.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { JobService } from "./job_pb";

/**
 * ListJobs returns jobs newest-first, optionally scoped to one city.
 *
 * @generated from rpc travplaces.v1.JobService.ListJobs
 */
export const listJobs = JobService.method.listJobs;

/**
 * GetJob returns one job by id.
 *
 * @generated from rpc travplaces.v1.JobService.GetJob
 */
export const getJob = JobService.method.getJob;

/**
 * CancelJob cancels a queued or running job.
 *
 * @generated from rpc travplaces.v1.JobService.CancelJob
 */
export const cancelJob = JobService.method.cancelJob;

/**
 * EnqueueImportOsm queues an OSM extract download for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueImportOsm
 */
export const enqueueImportOsm = JobService.method.enqueueImportOsm;

/**
 * EnqueueImportPois queues a POI import from the city's OSM extract.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueImportPois
 */
export const enqueueImportPois = JobService.method.enqueueImportPois;

/**
 * EnqueueImportFsq queues a Foursquare places import for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueImportFsq
 */
export const enqueueImportFsq = JobService.method.enqueueImportFsq;

/**
 * EnqueueBuildValhalla queues a Valhalla routing-tile build for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueBuildValhalla
 */
export const enqueueBuildValhalla = JobService.method.enqueueBuildValhalla;

/**
 * EnqueueBuildOtp queues an OTP transit-graph build for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueBuildOtp
 */
export const enqueueBuildOtp = JobService.method.enqueueBuildOtp;

/**
 * EnqueueBuildBasemap queues a basemap tile build for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueBuildBasemap
 */
export const enqueueBuildBasemap = JobService.method.enqueueBuildBasemap;

/**
 * EnqueueVerify queues a data-verification pass for a city.
 *
 * @generated from rpc travplaces.v1.JobService.EnqueueVerify
 */
export const enqueueVerify = JobService.method.enqueueVerify;
